const S = /* @__PURE__ */ new Set(["localhost", "127.0.0.1"]), _ = /* @__PURE__ */ new Set(["127.0.0.1", "::1", "::ffff:127.0.0.1"]), u = /^(localhost|127\.0\.0\.1)(:\d+)?$/, A = (s) => !!s && S.has(s), d = (s) => !!s && u.test(s), O = (s) => !!s && _.has(s), f = (s) => {
  if (!s) return !1;
  try {
    return A(new URL(s).hostname);
  } catch {
    return !1;
  }
}, R = ({
  host: s,
  remoteAddress: e
}) => O(e) && d(s), L = "LOTUS_LOCAL_AUTH_BYPASS", E = /* @__PURE__ */ new Set([
  "development",
  "test"
]), v = "127.0.0.1", t = (s) => ({
  enabled: !1,
  reason: s
}), h = ({
  env: s,
  localUrlVars: e
}) => {
  if (s[L] !== "1")
    return t(`${L} is not set to 1`);
  const r = s.NODE_ENV ?? "";
  if (!E.has(r))
    return t(
      `NODE_ENV is ${r || "unset"}; the bypass runs only under development or test`
    );
  if (s.CI !== void 0)
    return t("CI is set; the bypass runs only on a developer machine");
  if (e.length === 0)
    return t(
      "no local URL variables declared; refusing a vacuous locality check"
    );
  for (const o of e) {
    const n = s[o];
    if (!n) return t(`${o} is unset`);
    if (!f(n))
      return t(`${o} does not point at localhost / 127.0.0.1`);
  }
  return { enabled: !0 };
}, C = (s) => s.includes("@"), p = ["DATABASE_URL", "REDIS_URL"], T = ({
  flag: s,
  email: e,
  nodeEnv: r,
  hostname: o,
  apiUrl: n,
  ci: a
}) => {
  if (!e)
    return { email: void 0, reason: "no bypass email is configured" };
  if (o === void 0)
    return { email: void 0, reason: "not running in a browser" };
  const i = {
    LOTUS_LOCAL_AUTH_BYPASS: s,
    NODE_ENV: r
  };
  a !== void 0 && (i.CI = a), i.PAGE_ORIGIN = `http://${o}`;
  const c = ["PAGE_ORIGIN"];
  n !== void 0 && (i.API_URL = n, c.push("API_URL"));
  const l = h({ env: i, localUrlVars: c });
  return l.enabled ? A(o) ? { email: e } : {
    email: void 0,
    reason: `the page host ${o} is not localhost`
  } : { email: void 0, reason: l.reason };
}, U = (s, e) => s.CI !== void 0 ? "" : s[`${e}LOTUS_LOCAL_AUTH_BYPASS`] === "1" && s[`${e}AUTH_BYPASS_EMAIL`] || "";
export {
  L as LOCAL_BYPASS_FLAG,
  v as LOCAL_BYPASS_LISTEN_HOST,
  p as SERVER_LOCAL_URL_VARS,
  U as bypassEmailFromEnv,
  C as isBypassBearer,
  f as isLocalUrl,
  d as isLocalhostHostHeader,
  R as isLocalhostRequestOrigin,
  T as resolveClientBypass,
  h as resolveLocalBypass
};
